// extracted by mini-css-extract-plugin
module.exports = {"appeals_wrapper":"appeals_appeals_wrapper__q6kTq","appeals_wrapper_title":"appeals_appeals_wrapper_title__UdTTU","appeals_wrapper_content":"appeals_appeals_wrapper_content__1fihe"};